module.exports = __webpack_public_path__ + "img/usa-flag.8ddd9500.png";